import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {LogisticsVehicle} from "../../../logistics-vehicle/models/logistics-vehicle.model";
import {MapFactoryService} from "../../services/map.service";
import {MapsCommonService} from "../../services/mapsCommon.service";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class AgentsMapComponent implements IController {
  agents: any;
  logisticsVehicles: LogisticsVehicle[];
  onSelect: Function;

  private mapTypeIds = {
    roadmap: 'ROADMAP',
    satellite: 'SATELLITE'
  };
  private infowindow = new google.maps.InfoWindow();
  private map: any;
  private filters = {
    traffic: false,
    satellite: false,
    agents: true,
    showAgentsWithoutGpsPermissions: true,
    logisticsVehicles: true,
    logisticsVehiclesInfoWindows: false,
    agentsInfoWindows: false
  };
  private activeWindow = {
    show: false,
    coords: undefined
  };
  private myLocation = undefined;
  private markerEvents: any;
  private isReady: boolean;
  public logisticsVehiclesDataLayerRef: any;
  private siteLocation: any;
  private mapRef: any;
  private logisticsVehiclesInfoWindows: any[] = [];
  private agentsInfoWindows: any[] = [];


  constructor(private mapsCommonService: MapsCommonService, private $timeout: ITimeoutService,
              private agentsService: AgentsService, private splitService: SplitService,
              private $filter, private mapFactoryService: MapFactoryService, private $mdMedia) {
    this.filters.showAgentsWithoutGpsPermissions = !this.splitService.getEnableLocationTrackingFilterByDefault();
  }

  $onInit() {
    this.siteLocation = this.mapsCommonService.getSiteLocation();
    this.map = {
      isReady: false,
      center: this.siteLocation,
      zoom: 12,
      events: {
        idle: (map) => {
          if (!this.isReady) {
            this.mapRef = map;
            this.isReady = true;
            google.maps.event.trigger(map, 'resize');
          }
        },
        click: () => {
          this.$timeout(0).then(() => {
            if (!this.filters.agentsInfoWindows) {
              this._clearAllAgentsInfoWindows();
            }
          })
        }
      },
      logisticsVehiclesLayerEnable: true,
      logisticsVehiclesDataLayerCallback: (layer) => {
        this.logisticsVehiclesDataLayerRef = layer;

        if (!!this.filters.logisticsVehicles && this.logisticsVehicles) {
          this._setLogisticsVehicles(this.logisticsVehicles);
        }


        // Logistics Vehicles Events - mouseover
        this.logisticsVehiclesDataLayerRef.addListener("mouseover", (event) => {
          if (!this.filters.logisticsVehiclesInfoWindows) {
            this.$timeout(0).then(() => {
              const id = event.feature.getProperty('id');
              if (id) {
                this._setLogisticsVehiclesInfoWindows([id]);
              }
            });
          }
        });

        // Logistics Vehicles Events - mouseout
        this.logisticsVehiclesDataLayerRef.addListener("mouseout", (event) => {
          if (!this.filters.logisticsVehiclesInfoWindows) {
            this._clearAllLogisticsVehiclesInfoWindows();
          }
        });

      },
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        mapTypeControl: false,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId[this.mapTypeIds.roadmap]
      },
      bounds: {}
    }

    this.markerEvents = {
      click: (marker, eventName, model) => {
        if (!this.filters.agentsInfoWindows) {
          this._clearAllAgentsInfoWindows();
          this.$timeout(0).then(() => {
            this._setAgentsInfoWindows([model.id]);
          })
        }
        if (this.$mdMedia('gt-md')) {
          this.onSelect({agent: model})
        }
      },
      mouseover: (marker, event, model, args) => {
        if (!this.filters.agentsInfoWindows) {
          this._setAgentsInfoWindows([model.id]);
        }
      },
      mouseout: (marker, event, model, args) => {
        if (!this.filters.agentsInfoWindows) {
          this._clearAllAgentsInfoWindows();
        }
      }
    };
    this.mapFactoryService.getBrowserLocation()
      .then((res: any) => {
        this.myLocation = this.mapsCommonService.buildMyLocationMarker(res.coords);
      })
      .catch(function (err) {

      })
  }

  $onChanges(changes) {
    if (changes.agents) {
      this.setAgentMarkers(this.agents);

      const previousAccount = changes.agents.previousValue;
      if (!_.get(previousAccount, 'length')) {
        this.$timeout(0).then(() => {
          this.centerMap();
        })
      }
    }
    if (changes.logisticsVehicles && !changes.logisticsVehicles.isFirstChange()) {
      let currentLogisticsVehicles = _.get(changes.logisticsVehicles, 'currentValue', []),
        previousLogisticsVehicles = _.get(changes.logisticsVehicles, 'previousValue', []),
        logisticsVehiclesToRemove = _.differenceBy(previousLogisticsVehicles, currentLogisticsVehicles, 'id'),
        logisticsVehiclesToAdd = _.difference(currentLogisticsVehicles, previousLogisticsVehicles, 'id');

      const currentLogisticsVehiclesToUpdate = _.filter(currentLogisticsVehicles, (l: any) => {
        const previousLogisticVehicleRef = _.find(previousLogisticsVehicles, ['id', l.id]);
        // Check if route was changed
        return !!previousLogisticVehicleRef && previousLogisticVehicleRef.updatedAt < l.updatedAt;
      });

      if (currentLogisticsVehiclesToUpdate.length) {
        logisticsVehiclesToRemove = logisticsVehiclesToRemove.concat(currentLogisticsVehiclesToUpdate);
        logisticsVehiclesToAdd = logisticsVehiclesToAdd.concat(currentLogisticsVehiclesToUpdate);
      }

      // Remove Logistics Vehicles
      if (logisticsVehiclesToRemove.length) {
        const logisticsVehiclesIdsToRemove = _.map(logisticsVehiclesToRemove, 'id');
        this.logisticsVehiclesDataLayerRef?.forEach((feature) => {
          const id = feature.getProperty('id');
          if (_.includes(logisticsVehiclesIdsToRemove, id)) {
            this.logisticsVehiclesDataLayerRef.remove(feature);
          }
        });
      }

      // Add Logistics Vehicles
      if (logisticsVehiclesToAdd.length) {
        this._setLogisticsVehicles(logisticsVehiclesToAdd);
      }

      // if (!!this.filters.logisticsVehicles) {
      //   this._setLogisticsVehicles(this.logisticsVehicles);
      // }
    }
  }


  onLogisticsVehiclesInfoWindowsFilterChange(isEnabled) {
    this.filters.logisticsVehiclesInfoWindows = isEnabled;
    if (isEnabled) {
      this._setLogisticsVehiclesInfoWindows();
    } else {
      this._clearAllLogisticsVehiclesInfoWindows();
    }
  }

  onAgentsInfoWindowsFilterChange(isEnabled) {
    this.filters.agentsInfoWindows = isEnabled;
    if (isEnabled) {
      this._setAgentsInfoWindows();
    } else {
      this._clearAllAgentsInfoWindows();
    }
  }

  onMapTypeChange(isSatelliteEnabled) {
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
    if (isSatelliteEnabled) {
      this.filters.traffic = false;
    }
  }

  centerMap() {
    this.mapsCommonService.centerMapByBounds(this.map, this.agents);
  }

  onToggleAgents() {
    this.onToggleAgentsByGpsPermissionsChange(this.agents);
  }

  onToggleAgentsByGpsPermissionsChange(agents) {
    agents.forEach((a) => {
      if (!a.options) {
        a.options = {};
      }
      a.options.visible = !this.filters.showAgentsWithoutGpsPermissions ?
        (this.filters.agents && this.agentsService.doesAgentHasGpsPermissions(a)) :
        this.filters.agents;
    })
  }

  onToggleLogisticsVehicles() {
    this.map.logisticsVehiclesLayerEnable = !this.map.logisticsVehiclesLayerEnable;
  }

  private setAgentMarkers(agents) {
    _.forEach(agents, (agent) => {
      agent.icon = this.mapsCommonService.getAgentIcon(agent);
    })
    this.onToggleAgentsByGpsPermissionsChange(agents);
  }

  private _setLogisticsVehicles(logisticsVehicles) {
    if (this.logisticsVehiclesDataLayerRef) {
      const geoJson = this.mapsCommonService.convertLogisticsVehiclesToGeoJson(logisticsVehicles);

      // Add routes to layer
      this.logisticsVehiclesDataLayerRef.addGeoJson(geoJson);

      // Set feature style by its properties
      this.setLogisticsVehiclesStyle();
    }
  }

  private setLogisticsVehiclesStyle() {
    if (this.logisticsVehiclesDataLayerRef) {
      this.logisticsVehiclesDataLayerRef.setStyle((feature) => {
        // const routeId = feature.getProperty('routeId'),
        //   jobId = feature.getProperty('jobId'),
        //   isVisible = _.includes(this.hiddenRouteIds, routeId) ? false : this.filters.routes,
        //   isSelected = _.includes(this.selectedJobIds, jobId);
        // isSelected = _.isEqual(feature.getProperty('id'), ctrl.selectedActivityId);

        return this.mapsCommonService.getLogisticsVehicleStyle(feature);
      });
    }
  }

  private _setLogisticsVehiclesInfoWindows(logisticsVehicleIds?) {
    this.logisticsVehiclesDataLayerRef?.forEach((feature) => {
      const id = feature.getProperty('id');
      if (!logisticsVehicleIds || _.includes(logisticsVehicleIds, id)) {
        const coordinates = feature.getProperty("coordinates");
        const name = feature.getProperty("name");

        const eventMarker = new google.maps.MVCObject();
        eventMarker.set('position', coordinates);

        const infowindow = new google.maps.InfoWindow({
          content: name,
          pixelOffset: new google.maps.Size(0, -20),
          disableAutoPan: true
        });
        infowindow.open(this.mapRef, eventMarker);
        this.logisticsVehiclesInfoWindows.push(infowindow);
      }
    });
  }

  private _clearAllLogisticsVehiclesInfoWindows() {
    _.forEach(this.logisticsVehiclesInfoWindows, (infoWindow) => {
      infoWindow.close();
    })
    this.logisticsVehiclesInfoWindows = [];

  }

  private _setAgentsInfoWindows(agentIds?) {
    this.agents.forEach((a) => {
      if (!agentIds || _.includes(agentIds, a.id)) {
        let coordinates = {
          lat: a.lastKnownLocation?.coordinates?.latitude,
          lng: a.lastKnownLocation?.coordinates?.longitude
        };


        const name = this.$filter('userName')(a.user);

        const eventMarker = new google.maps.MVCObject();
        eventMarker.set('position', coordinates);

        const infowindow = new google.maps.InfoWindow({
          content: name,
          pixelOffset: new google.maps.Size(0, -20),
          disableAutoPan: true
        });
        infowindow.open(this.mapRef, eventMarker);
        this.agentsInfoWindows.push(infowindow);
      }
    });
  }

  private _clearAllAgentsInfoWindows() {
    _.forEach(this.agentsInfoWindows, (infoWindow) => {
      infoWindow.close();
    })
    this.agentsInfoWindows = [];
  }

}

angular
  .module('bringoz.admin.map')
  .component('agentsMap', {
    bindings: {
      agents: '<',
      logisticsVehicles: '<?',
      onSelect: '&'
    },
    template: require('./agents-map.html').default,
    controller: AgentsMapComponent
  });
